export const emptySetText = `There are no listings found...`;
